import * as React from 'react';

export function useEffectOnce(effect: React.EffectCallback) {
  // eslint-disable-next-line
  React.useEffect(effect, []);
}
